module.exports = __webpack_public_path__ + "media/images/lane/icon_calendar-e2fc3e9d721621a2f2b037518257e8e1.svg";